<script>
    export default {
        name: "Admin Sidebar",
        props: {
            activeRoute: {
                type: String,
                required: true,
                default: "adm-main"
            }
        },
        methods: {
          setActive: (id) => {
              const elems = document.querySelectorAll(".menu-elem-outer");
              for (let elem of elems) {
                  if (elem.classList.contains("active")) elem.classList.remove("active")
              }
              document.querySelector("#" + id).classList.add("active")
          }
        },
        mounted() {
            this.setActive(this.activeRoute)
        },
        updated() {
            this.setActive(this.activeRoute)
        }
    }
</script>

<template>
    <div class="admin-sidebar sidebar">
        <div class="menu-elem-outer" id="adm-main">
            <div class="menu-elem">
                <div class="menu-icn">
                    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.0702 3.2096L5.2702 3.8344C4.0574 4.7816 3.4502 5.2552 3.1254 5.9224C2.7998 6.5904 2.7998 7.3616 2.7998 8.904V10.5776C2.7998 13.6048 2.7998 15.1184 3.7374 16.0592C4.675 17 6.183 17 9.1998 17H10.7998C13.8166 17 15.3254 17 16.2622 16.0592C17.199 15.1184 17.1998 13.6048 17.1998 10.5768V8.9048C17.1998 7.3616 17.1998 6.5904 16.8742 5.9224C16.5486 5.2552 15.9422 4.7816 14.7294 3.8344L13.9294 3.2104C12.0414 1.736 11.0974 1 9.9998 1C8.9022 1 7.9582 1.736 6.0702 3.2096Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <router-link to="/admin/main"><span>Главная</span></router-link>
            </div>
        </div>
        <div class="menu-elem-outer" id="adm-pages">
            <div class="menu-elem">
                <div class="menu-icn">
                    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.5 0H7.5C6.96957 0 6.46086 0.210714 6.08579 0.585786C5.71071 0.960859 5.5 1.46957 5.5 2C4.96957 2 4.46086 2.21071 4.08579 2.58579C3.71071 2.96086 3.5 3.46957 3.5 4V14C3.5 14.5304 3.71071 15.0391 4.08579 15.4142C4.46086 15.7893 4.96957 16 5.5 16H12.5C13.0304 16 13.5391 15.7893 13.9142 15.4142C14.2893 15.0391 14.5 14.5304 14.5 14C15.0304 14 15.5391 13.7893 15.9142 13.4142C16.2893 13.0391 16.5 12.5304 16.5 12V2C16.5 1.46957 16.2893 0.960859 15.9142 0.585786C15.5391 0.210714 15.0304 0 14.5 0ZM14.5 13V4C14.5 3.46957 14.2893 2.96086 13.9142 2.58579C13.5391 2.21071 13.0304 2 12.5 2H6.5C6.5 1.73478 6.60536 1.48043 6.79289 1.29289C6.98043 1.10536 7.23478 1 7.5 1H14.5C14.7652 1 15.0196 1.10536 15.2071 1.29289C15.3946 1.48043 15.5 1.73478 15.5 2V12C15.5 12.2652 15.3946 12.5196 15.2071 12.7071C15.0196 12.8946 14.7652 13 14.5 13ZM4.5 4C4.5 3.73478 4.60536 3.48043 4.79289 3.29289C4.98043 3.10536 5.23478 3 5.5 3H12.5C12.7652 3 13.0196 3.10536 13.2071 3.29289C13.3946 3.48043 13.5 3.73478 13.5 4V14C13.5 14.2652 13.3946 14.5196 13.2071 14.7071C13.0196 14.8946 12.7652 15 12.5 15H5.5C5.23478 15 4.98043 14.8946 4.79289 14.7071C4.60536 14.5196 4.5 14.2652 4.5 14V4Z" fill="black"/>
                    </svg>
                </div>
                <router-link to="/admin/pages"><span>Страницы</span></router-link>
            </div>
        </div>
        <div class="menu-elem-outer" id="adm-products">
            <div class="menu-elem">
                <div class="menu-icn">
                    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.99968 0L17.1146 3.55746V12.4511L9.99968 16L2.88477 12.4511V3.55746L9.99968 0ZM15.3444 3.89952L9.99968 1.23143L7.93875 2.25762L13.2493 4.94281L15.3444 3.89952ZM9.99968 6.56761L12.035 5.55853L6.71587 2.87333L4.65494 3.89952L9.99968 6.56761ZM3.97937 4.78888V11.767L9.45238 14.5035V7.52539L3.97937 4.78888ZM10.547 14.5035L16.02 11.767V4.78888L10.547 7.52539V14.5035Z" fill="black"/>
                    </svg>
                </div>
                <router-link to="/admin/products"><span>Товары</span></router-link>
            </div>
        </div>
        <div class="menu-elem-outer" id="adm-orders">
            <div class="menu-elem">
                <div class="menu-icn">
                    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.7062 1H3.29446C2.25487 1 1.41211 1.84276 1.41211 2.88235V15.1176C1.41211 16.1572 2.25487 17 3.29446 17H12.7062C13.7458 17 14.5886 16.1572 14.5886 15.1176V2.88235C14.5886 1.84276 13.7458 1 12.7062 1Z" stroke="black"/>
                        <path d="M5.17676 5.70605H10.8238M5.17676 9.47076H10.8238M5.17676 13.2355H8.94146" stroke="black" stroke-linecap="round"/>
                    </svg>
                </div>
                <router-link to="/admin/orders"><span>Заказы</span></router-link>
            </div>
        </div>
        <div class="menu-elem-outer" id="adm-users">
            <div class="menu-elem">
                <div class="menu-icn">
                    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 17V15.2222C2 14.2792 2.3746 13.3749 3.0414 12.7081C3.70819 12.0413 4.61256 11.6667 5.55556 11.6667H9.11111C10.0541 11.6667 10.9585 12.0413 11.6253 12.7081C12.2921 13.3749 12.6667 14.2792 12.6667 15.2222V17M13.5556 1.11556C14.3204 1.31138 14.9983 1.75618 15.4823 2.37983C15.9664 3.00348 16.2292 3.77052 16.2292 4.56C16.2292 5.34948 15.9664 6.11652 15.4823 6.74017C14.9983 7.36382 14.3204 7.80862 13.5556 8.00444M18 17V15.2222C17.9955 14.4375 17.7315 13.6763 17.2491 13.0572C16.7668 12.4382 16.0932 11.9962 15.3333 11.8M3.77778 4.55556C3.77778 5.49855 4.15238 6.40292 4.81918 7.06971C5.48597 7.73651 6.39034 8.11111 7.33333 8.11111C8.27633 8.11111 9.1807 7.73651 9.84749 7.06971C10.5143 6.40292 10.8889 5.49855 10.8889 4.55556C10.8889 3.61256 10.5143 2.70819 9.84749 2.0414C9.1807 1.3746 8.27633 1 7.33333 1C6.39034 1 5.48597 1.3746 4.81918 2.0414C4.15238 2.70819 3.77778 3.61256 3.77778 4.55556Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <router-link to="/admin/users"><span>Пользователи</span></router-link>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
@use '~@/assets/styles/vars' as *;

.admin-sidebar {
        min-width: 18.75%;
        width: 18.75%;
        background: $light-gray;
        min-height: 100vh;
    }

    .menu-elem-outer {
        padding: 0 18.66%;
    }

    .menu-elem-outer.active {
        background: $white;
    }

    .menu-elem {
        padding: 15px 0;
        text-align: left;

        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 3%;
    }

    .menu-elem span {
        font-weight: 500;
        font-size: 16px;
        line-height: 90% !important;
    }

    .menu-icn {
        min-width: 30px;
        width: auto;

        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
